import { TSearchHistory } from '@/store/models/search.model';

import { IBaseAction, IBaseState } from '@/store/types/base.state';

export enum SearchHistoryActionTypes {
  ADD_SEARCH_HISTORY = 'SEARCH_HISTORY.ADD_SEARCH_HISTORY',
  REMOVE_SEARCH_HISTORY = 'SEARCH_HISTORY.REMOVE_SEARCH_HISTORY',
  CLEAR_SEARCH_HISTORY = 'SEARCH_HISTORY.CLEAR_SEARCH_HISTORY',
}

export interface IAddSearchHistoryAction extends IBaseAction {
  type: typeof SearchHistoryActionTypes.ADD_SEARCH_HISTORY;
  searchHistory: TSearchHistory;
}

export interface IRemoveSearchHistoryAction extends IBaseAction {
  type: typeof SearchHistoryActionTypes.REMOVE_SEARCH_HISTORY;
  indexToRemove: number;
}

export interface IClearSearchHistoryAction extends IBaseAction {
  type: typeof SearchHistoryActionTypes.CLEAR_SEARCH_HISTORY;
}

export type TSearchHistoryAction = IAddSearchHistoryAction | IRemoveSearchHistoryAction | IClearSearchHistoryAction;

export interface ISearchHistoryState extends IBaseState {
  searchHistoric: TSearchHistory[];
}
